import { useState } from "react";

export type ListView = "table" | "card";

/**
 * Vista lista (tabella/card) su desktop, persistita in localStorage per chiave.
 * Su mobile le liste restano sempre a card a prescindere.
 */
export function useListView(key: string): [ListView, (v: ListView) => void] {
  const storageKey = `listview:${key}`;
  const [view, setViewState] = useState<ListView>(() =>
    localStorage.getItem(storageKey) === "card" ? "card" : "table",
  );
  const setView = (v: ListView) => {
    localStorage.setItem(storageKey, v);
    setViewState(v);
  };
  return [view, setView];
}
